import React from 'react'
import Image from "../../asserts/images/e.png" ;

function Scolarite() {
  return (

    <div className='contentimagesDirection'>
    <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
                <p>Responsable des emplois :<br/> Adel Ayed</p>
                <p id='email1'><i class="fa-regular fa-envelope"></i> ayedadel84@yahoo.fr</p>
            </div>
        </div>
        
        <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
                <p>Responsable des emplois :<br/>Anis Sayedi</p>
                <p id='email2'><i class="fa-regular fa-envelope"></i> sayedi.enis@gmail.com</p>
            </div>
        </div>
        <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
                <p>Scolarité 3ème cycle : <br/> Faeik Frigui</p>
                <p id='email1'><i class="fa-regular fa-envelope"></i> faeik.frigui@gmail.com</p>
            </div>
        </div>
        
        <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
                <p>Responsable des stages : <br/>Faouzi Fekihh</p>
                <p id='email2'><i class="fa-regular fa-envelope"></i> fekihfaouzi@gmail.com</p>
            </div>
        </div>
       
        <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
                <p>Responsable des salles : <br/> Hamdi Mabrouk</p>
                <p id='email2'><i class="fa-regular fa-envelope"></i> hamdimabrouk305@gmail.com</p>
            </div>
        </div>
        
        <div className="carteEnseignant">
            <div className='imgcardEnseignant'>
                <img src={Image}></img>
            </div>
            <div className='descr'> 
                <p>Scolarité 3ème cycle  : <br/>  Zouari Safa</p>
                <p id='email2'><i class="fa-regular fa-envelope"></i> safa.zouari@gmail.com</p>
            </div>
        </div>
    </div>
   
  )
}

export default Scolarite